export default __webpack_public_path__ + "static/media/mjzj.618d1407.png";